/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerComplianceStatus } from './';
import {
    FreelancerComplianceStatusFromJSON,
    FreelancerComplianceStatusFromJSONTyped,
    FreelancerComplianceStatusToJSON,
} from './';
import type { SentQuotePostponeReason } from './';
import {
    SentQuotePostponeReasonFromJSON,
    SentQuotePostponeReasonFromJSONTyped,
    SentQuotePostponeReasonToJSON,
} from './';

/**
 * 
 * @export
 * @interface SendQuoteResource
 */
export interface SendQuoteResource {
    /**
     * 
     * @type {string}
     * @memberof SendQuoteResource
     */
    id: string;
    /**
     * 
     * @type {SentQuotePostponeReason}
     * @memberof SendQuoteResource
     */
    postponedReason?: SentQuotePostponeReason;
    /**
     * 
     * @type {boolean}
     * @memberof SendQuoteResource
     */
    quoteSentToClient?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SendQuoteResource
     */
    hasBypass?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SendQuoteResource
     */
    isFreelancerCarriedByAnUmbrella?: boolean;
    /**
     * 
     * @type {FreelancerComplianceStatus}
     * @memberof SendQuoteResource
     */
    complianceStatus?: FreelancerComplianceStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SendQuoteResource
     */
    verificationPostponed?: boolean;
}

/**
 * Check if a given object implements the SendQuoteResource interface.
 */
export function instanceOfSendQuoteResource(value: object): value is SendQuoteResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function SendQuoteResourceFromJSON(json: any): SendQuoteResource {
    return SendQuoteResourceFromJSONTyped(json, false);
}

export function SendQuoteResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendQuoteResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'postponedReason': json['postponedReason'] == null ? undefined : SentQuotePostponeReasonFromJSON(json['postponedReason']),
        'quoteSentToClient': json['quoteSentToClient'] == null ? undefined : json['quoteSentToClient'],
        'hasBypass': json['hasBypass'] == null ? undefined : json['hasBypass'],
        'isFreelancerCarriedByAnUmbrella': json['isFreelancerCarriedByAnUmbrella'] == null ? undefined : json['isFreelancerCarriedByAnUmbrella'],
        'complianceStatus': json['complianceStatus'] == null ? undefined : FreelancerComplianceStatusFromJSON(json['complianceStatus']),
        'verificationPostponed': json['verificationPostponed'] == null ? undefined : json['verificationPostponed'],
    };
}

export function SendQuoteResourceToJSON(value?: SendQuoteResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'postponedReason': SentQuotePostponeReasonToJSON(value['postponedReason']),
        'quoteSentToClient': value['quoteSentToClient'],
        'hasBypass': value['hasBypass'],
        'isFreelancerCarriedByAnUmbrella': value['isFreelancerCarriedByAnUmbrella'],
        'complianceStatus': FreelancerComplianceStatusToJSON(value['complianceStatus']),
        'verificationPostponed': value['verificationPostponed'],
    };
}

